import React from "react";
import Steps from "./../../assets/img/production-steps.gif";

const ProductionStages = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Stages of Production</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <img
          src={Steps}
          alt="Seed Production"
          className="img-fluid rounded shadow-sm"
        />
        <h5 className="mt-2">Breeder Seed - Foundation Seed</h5>
        <h6 className="mt-2">Steps Involved:</h6>
        <ol>
          <li className="mb-2">
            Allotment of Breeder seed is obtained from GOI, ICAR and Haryana
            Govt.
          </li>
          <li className="mb-2">Breeder seed is lifted from allotted institutes.</li>
          <li className="mb-2">
            Quality Testing is done to ensure quality of own produced seed
            before releasing to farmers.
          </li>
          <li className="mb-2">
            Breeder Seed are distributed to identified growers and Govt. Seed
            Farm for producing Foundation Seed.
          </li>
          <li className="mb-2">
            Field inspection of Foundation Seed plots / fields is done by a
            expert monitoring team.
          </li>
          <li className="mb-2">Roguing, plant protection measures etc. are arranged.</li>
          <li className="mb-2">
            Field inspection by Certification Agency and technical staff of HSDC
            is arranged.
          </li>
          <li className="mb-2">
            Samples are collected from the raw seed at the time of intake for
            quality analysis.
          </li>
          <li className="mb-2">
            Raw seed of duly inspected &amp; certified fields is processed.
          </li>
          <li className="mb-2">
            After processing, sampling &amp; testing as well as Grow-Out Test is
            conducted by Certification Agency.
          </li>
          <li className="mb-2">Packing and storage.</li>
        </ol>

        <h5 className="mt-2">Foundation Seed - Certified Seed</h5>
        <h6 className="mt-2">Steps Involved:</h6>
        <ol>
          <li className="mb-2">
            Seed is distributed to Shareholder &amp; Identified Growers for
            producing Certified seed.
          </li>
          <li className="mb-2">
            Field inspection / monitoring of certified seed fields is done.
          </li>
          <li className="mb-2">
            Rouging, Plant Protection measures, Cultural Practices etc are
            ensured.
          </li>
          <li className="mb-2">
            Field inspection by Certification Agency and technical staff of HSDC
            is arranged.
          </li>
          <li className="mb-2">
            Samples from raw seed of inspected / certified fields are collected
            at the time of arrival at plant for quality analysis.
          </li>
          <li className="mb-2">
            Processing of raw seed of inspected &amp; certified fields is done
            under the supervision of HSSCA and technical staff of HSDC.
          </li>
          <li className="mb-2">
            After processing, sampling &amp; testing is done by Seed
            Certification agency.
          </li>
          <li className="mb-2">Packing and storage.</li>
        </ol>
      </div>
    </div>
  );
};

export default ProductionStages;
